<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="老师姓名：">
            <el-input v-model="query.realName" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="老师手机号：">
            <el-input v-model="query.mobile" placeholder="请输入老师手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in options.technicalServiceLevel" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select v-model="query.sysDepartmentId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in options.sectionOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上级手机号：">
            <el-input v-model="query.parentMobile" placeholder="请输入上级手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="管辖区域：">
            <el-cascader :props="cascaderProps" v-model="areaArr" :options="regionOptions" clearable size="small"></el-cascader>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="加入时间" :value="1"></el-option>
              <el-option label="离职时间" :value="2"></el-option>
              <el-option label="修改时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="在职" name="1"></el-tab-pane>
          <el-tab-pane label="离职" name="2"></el-tab-pane>
          <el-tab-pane label="离职交接中" name="3"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['technical:manage:export']">导出</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['technical:manage:add']">添加老师</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" :key="activeName">
        <el-table-column type="selection" width="50" />
        <el-table-column label="基础信息" prop="name" align="center" width="160" fixed>
          <template slot-scope="{row}">
            <div>老师id: {{ row.id }}</div>
            <div>用户id：{{ row.userId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="老师信息" prop="name" align="center" width="160" fixed>
          <template slot-scope="{row}">
            <div @click="handleShow(row)">
              <el-link type="primary">{{row.realName}}</el-link><br />
              <el-link type="primary">{{row.mobile}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="activeName==2?'离职前身份':'身份'" prop="levelName" align="center" fixed />
        <el-table-column label="部门" prop="sysDepartmentName" align="center" />
        <el-table-column label="上级信息" prop="orderNo" align="center" width="200" v-if="activeName!=2">
          <template slot-scope="{row}">
            {{row.parentRealName}}{{row.parentLevelName?'(' + row.parentLevelName + ')':''}}<br />
            {{row.parentMobile}}
          </template>
        </el-table-column>
        <el-table-column label="所属督导" prop="supervisorRealName" align="center" width="100" v-if="activeName!=2 && !isServiceTeacher" />
        <el-table-column label="所在区域" prop="areaCount" align="center" v-if="activeName!=2" width="170">
          <template slot-scope="{row}">
            {{row.provinceName}}{{row.cityName}}{{row.districtName}}
          </template>
        </el-table-column>
        <el-table-column label="管辖区域数量" prop="areaCount" align="center" v-if="activeName!=2" width="120">
          <template slot-scope="{row}">
            <el-link type="primary" @click="showArea(row,row.areaCount)">{{row.areaCount}}</el-link><br />
          </template>
        </el-table-column>
        <el-table-column :label="isServiceTeacher?'直属大客户人数':'下级团队人数'" prop="childCount" align="center" v-if="activeName!=2" width="120" >
          <template slot-scope="{row}">
            {{isServiceTeacher?row.customerCount : row.childCount}}
          </template>
        </el-table-column>
        <el-table-column label="总业绩" prop="performance" align="center" v-if="activeName!=2" />
        <el-table-column label="加入时间" prop="createdTime" sortable="custom" align="center" width="200" v-if="activeName!=2" />
        <el-table-column label="离职时间" prop="resignTime" sortable="custom" align="center" width="200" v-if="activeName==2">
          <template slot-scope="{row}">
            {{row.resignTime}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" v-if="activeName!=2" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="250px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)" v-if="activeName==1" v-hasPermi="['technical:manage:edit']">编辑</el-button>
            <el-button type="text" v-if="activeName==3">离职交接中</el-button>
            <el-button type="text" @click="handleUpdate(row,2)" v-if="activeName==1" v-hasPermi="['technical:manage:identity']">修改身份</el-button>
            <el-button type="text" @click="handleUpdate(row,5)" v-if="activeName==1" v-hasPermi="['technical:manage:area']">添加区域</el-button>
            <el-button type="text" @click="handleUpdate(row,6)" v-if="activeName==2" v-hasPermi="['technical:manage:setas']">设为在职</el-button>
            <el-button type="text" @click="handleLizhi(row)" v-if="activeName==3" v-hasPermi="['technical:manage:setas']">设为离职</el-button>
            <el-button type="text" @click="handleLog(row)" v-if="activeName==2">日志记录</el-button>
            <el-dropdown @command="handleCommand" v-if="activeName==1">
              <el-button type="text">更多<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['technical:manage:setas']">设为离职</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,3)" v-if="row.levelId!=3 && row.childCount" v-hasPermi="['technical:manage:team']">{{ isServiceTeacher ? '下级成员' : '团队调整' }}</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,7)" v-if="row.customerCount" v-hasPermi="['technical:manage:customer']">{{isServiceTeacher?'大客户':'客户'}}调整</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,8)" v-if="row.areaCount" v-hasPermi="['technical:manage:delarea']">移除区域</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,4)" v-if="row.levelId!=1" v-hasPermi="['technical:manage:superiors']">调整上级</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,13)" v-if="row.levelId!=1 && row.levelId!=7 && row.levelId!=2" v-hasPermi="['technical:manage:superiors']">分配督导</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,11)">恢复登录</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,12)">清除缓存</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,10)">日志记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <technicalManage-add ref="technicalManageAdd" @created="doQueryList({})" :isServiceTeacher="isServiceTeacher" :addressList="regionOptions" :technicalServiceLevel="options.technicalServiceLevel" :popType="popType" />
    <technical-quit ref="technicalQuit" @created="doQueryList({})" :isServiceTeacher="isServiceTeacher" />
    <technical-adjust ref="technicalAdjust" @created="doQueryList({})" :popType="popType" :isServiceTeacher="isServiceTeacher" />
    <area-remove ref="areaRemove" @created="doQueryList({})" />
    <supervisor-assign ref="supervisorAssign" @created="doQueryList({})" />
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <div class="dialog-box">
        <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import technicalManageAdd from './add'
import technicalQuit from './quit.vue'
import sysAddrApi from '@/api/sys/sysAddr'
import technicalAdjust from './adjust.vue'
import areaRemove from './areaRemove.vue'
import supervisorAssign from './supervisor.vue'
import technicianInfoApi from '@/api/technical/technicianInfo'
import Pagination from '@/components/Pagination'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import sysDepartmentApi from '@/api/config/sysDepartment'
import technicianAreaApi from '@/api/technical/technicianArea'
import userApi from '@/api/sys/user'
export default {
  props: ['isServiceTeacher'],
  components: {
    Pagination,
    technicalManageAdd,
    technicalQuit,
    technicalAdjust,
    areaRemove,
    supervisorAssign
  },
  data() {
    // status 10  在职   20 离职交接   30 离职
    return {
      popType: 0, //0:新增 1:编辑 2:修改身份 3:团队调整-添加老师 4:调整上级 5调整区域 6 设为在职 7：客户调整
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
      },
      areaArr: [],
      list: [],
      total: 0,
      listLoading: true,
      formVisible: false,
      query: {
        pageNo: 1,
        pageSize: 10,
        // name: undefined,
        // isEnable: undefined,
      },
      selectItems: [],
      activeName: '1',
      options: {
        technicalServiceLevel: [],
        sectionOption: []
      },
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      areaOptions: [],
      regionOptions: [],
      dateTime: null
    }
  },
  created() {
    // this.regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
    // console.log('regionOptions: ',regionOptions);
    // this.regionOptions = regionOptions
    this.getTechnicalServiceLevel()
    this.getAddressList()
    this.getSectionOption()
    this.doQueryList({
      pageNo: 1
    })
  },
  methods: {
    getTechnicalServiceLevel() {
      let params = { pageSize: 1000 }
      if (this.isServiceTeacher) params.isBigCustomer = true
      else params.isOrdinary = true
      technicalServiceLevelApi.fetchList(params).then(({ data }) => {
        this.options.technicalServiceLevel = data.list
      })
    },
    // 获取部门
    getSectionOption() {
      sysDepartmentApi.getMiniList({ pageNo: 1, pageSize: 1000 }).then(({ data }) => {
        this.options.sectionOption = data.list
        // console.log('地区列表: ',data);
      })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.regionOptions = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10
      }
      this.dateTime = []
      this.areaArr = null
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    showArea(row, num) {
      if (!num) return
      this.changeIdentity(row)
    },
    // 获取区域列表
    changeIdentity(row) {
      let obj = {}
      obj.techInfoId = row.id
      obj.parentTechInfoId = row.parentId
      obj.addOrDelete = 2
      obj.v = 3
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      technicianAreaApi.fetchTreeList(obj).then(({ data }) => {
        this.loading.close()
        if (data) {
          this.areaOptions = data;
          this.formVisible = true
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    /**
     * 列表tab切换
     */
    handleClick() {
      console.log('val: ', this.activeName);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    clacPrams() {
      this.query.areaProvinceCode = this.areaArr && this.areaArr.length ? this.areaArr[0] : undefined
      this.query.areaCityCode = this.areaArr && this.areaArr.length ? this.areaArr[1] : undefined
      this.query.areaDistrictCode = this.areaArr && this.areaArr.length ? this.areaArr[2] : undefined
      this.query.status = this.activeName == '1' ? 10 : this.activeName == '2' ? 30 : 20
    },
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.clacPrams()
      let query = {
        ...this.query
      }
      if (this.areaArr && this.areaArr.length) {
        query.areaProvinceCode = this.areaArr[0]
        query.areaCityCode = this.areaArr[1]
        query.areaDistrictCode = this.areaArr[2]
      }
      if (this.dateTime && this.dateTime.length) {
        if (this.query.isEnable == 1) {
          query.createdTimeStart = this.dateTime[0]
          query.createdTimeEnd = this.dateTime[1]
        }
        if (this.query.isEnable == 2) {
          query.resignTimeStart = this.dateTime[0]
          query.resignTimeEnd = this.dateTime[1]
        }
        if (this.query.isEnable == 3) {
          query.operatedTimeStart = this.dateTime[0]
          query.operatedTimeEnd = this.dateTime[1]
        }
      }
      if (this.isServiceTeacher) {
        query.levelIsBigCustomer = true
      } else {
        query.levelIsOrdinary = true
      }
      delete query.isEnable
      this.listLoading = true
      return technicianInfoApi.fetchList(query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => technicianInfoApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => technicianInfoApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      // console.log(command,'11111111')
      // return
      this.popType = command.command
      //离职
      if (command.command === 1) {
        // this.$common.confirm('是否确认提交离职，离职后该老师无法享受技术老师权益')
        //   .then(() => this.$refs.technicalQuit.handleQuit(command.row))
        this.handleLizhi(command.row)
      } else if ([2, 5, 4].includes(command.command)) {

        this.$refs.technicalManageAdd.handleUpdate(command)
        // this.handleBatchState(ids, 2)
      } else if ([3, 7].includes(command.command)) {
        this.$refs.technicalAdjust.handleUpdate(command)
      } else if (command.command == 8) {
        this.$refs.areaRemove.handleUpdate(command.row)
      } else if (command.command == 10) {
        this.$router.push("/log/log?type=20&id=" + command.row.id);
      } else if (command.command == 11) {
        this.handleEntryInhibited(command.row);
      } else if (command.command == 12) {
        this.handleClearCache(command.row);
      } else if (command.command == 13) {
        this.$refs.supervisorAssign.open(command.row);
      }
    },
    handleLizhi(row) {
      if (!row.customerCount && !row.childCount && !row.areaCount) {
          let Ins = this.isServiceTeacher ? technicianInfoApi.transferForBig : technicianInfoApi.resignQuit
          let params = { id: row.id, areaDetail: [], childDetail: [], customerDetail: [] }
          this.$common.confirm('是否确认提交离职，离职后该老师无法享受技术老师权益').then(() => technicianInfoApi.resignQuit(params))
            .then(() => {
              setTimeout(() => {
                this.doQueryList({})
              }, 1000)
            });
        } else {
          this.$refs.technicalQuit.handleQuit(row)
        }
    },
    handleClearCache(row) {
      this.$common.confirm('是否确认清除缓存')
        .then(() => userApi.delCache({ userId: row.userId }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleEntryInhibited(row) {
      // this.$common.confirm(row.entryInhibited ? '是否确认恢复登录' : '是否确认禁止用户登录，禁用了客户不能登录app').then(
      this.$common.confirm('是否确认恢复登录').then(
        async () => {
          await userApi.updateEntryInhibited({
            entryInhibited: 0,
            id: row.userId
          })
        }).then(() => {
          this.$common.showMsg('success', `恢复成功`)
          this.doQueryList({ pageNo: 1 })
        })
    },
    handleLog(row) {
      this.$router.push("/log/log?type=20&id=" + row.id);
    },
    changeSwitch(row) {
      technicianInfoApi.setIsEnable({
        id: row.id,
        isEnable: row.isEnable
      }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      technicianInfoApi.getImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.popType = 0
      this.$refs.technicalManageAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row, type) {
      console.log('type: ', type, row);
      this.popType = type
      if (type == 6 && row.levelId == 1) {
        this.$common.confirm('是否确认设为在职')
          .then(() => {
            technicianInfoApi.onTheJob({ id: row.id, parentId: row.parentId }).then((res) => {
              if (res.code === '0') {
                this.$message.success(res.msg || '操作成功')
                this.doQueryList({})
              } else {
                this.$message.error(res.msg);
              }
            });
          })
      } else {
        this.$refs.technicalManageAdd.handleUpdate({
          row,
          command: type
        })
      }

    },
    handleDownload() {
      this.$router.push("/export/list?code=EEForTechInfo")
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-box {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
